<template>
    <div class="popup">
        <div class="VPopup-background"></div>
        <div
            ref="wrapper"
            class="VPopup"
            role="dialog"
            @keydown.enter="enter"
        >
            <div
                class="VPopup__dialog"
                role="document"
            >
                <div class="VPopup__content">
                    <div
                        ref="header"
                        class="VPopup__header header"
                        v-if="isShowHeader"
                    >
                        <slot name="header">
                        <span class="header__title">
                            {{ title }}
                        </span>
                            <button
                                type="button"
                                class="header__close"
                                @click="cancel"
                            >
                            </button>
                        </slot>
                    </div>
                    <div class="VPopup__body">
                        <div
                            class="VPopup__body__sidebar"
                            v-if="isShowSidebar"
                        >
                            <slot name="sidebar"></slot>
                        </div>
                        <div class="VPopup__body__content">
                            <slot></slot>
                        </div>
                    </div>
                    <div
                        class="VPopup__footer footer"
                        v-if="isShowFooter"
                    >
                        <slot name="footer">
                            <slot name="beforeButtons"></slot>
                            <div class="buttons">
                                <v-button
                                    v-if="isShowCancelButton"
                                    type="button"
                                    theme="dark-blue"
                                    @click="cancel"
                                >
                                    {{ cancelButtonText }}
                                </v-button>
                                <v-button
                                    v-if="isShowSubmitButton"
                                    :disabled="isDisableSubmitButton"
                                    type="button"
                                    theme="green"
                                    @click="submit"
                                >
                                    {{ submitButtonText }}
                                </v-button>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    export default {
        name: 'VFullScreenPopup',
        props: {
            isShown: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
            width: {
                type: Number,
                default: 520,
            },
            isDisableSubmitButton: {
                type: Boolean,
                default: false,
            },
            isShowCancelButton: {
                type: Boolean,
                default: true,
            },
            isShowSubmitButton: {
                type: Boolean,
                default: true,
            },
            isShowSidebar: {
                type: Boolean,
                default: true,
            },
            isShowHeader: {
                type: Boolean,
                default: true,
            },
            isShowFooter: {
                type: Boolean,
                default: true,
            },
            cancelButtonText: {
                type: String,
                default: 'Cancel',
            },
            submitButtonText: {
                type: String,
                default: 'Submit',
            },
        },
        mounted() {
            document.querySelector('body').style.overflow = 'hidden';
            document.body.addEventListener('keydown', this.escapeClick, false);
        },
        beforeDestroy() {
            document.querySelector('body').style.overflow = 'auto';
            document.body.removeEventListener('keydown', this.escapeClick, false);
        },
        methods: {
            escapeClick(e) {
                e = e || window.event;
                const key = e.which || e.keyCode; // keyCode detection
                if (key === 27) {
                    this.cancel();
                }
                return null;
            },
            cancel() {
                this.$emit('cancel');
                this.$emit('update:isShown', false);
            },
            submit() {
                this.$emit('submit');
            },
            enter() {
                this.$emit('enter');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .popup {
        z-index: 100000000;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        
        .VPopup-background {
            top: 0;
            left: 0;
            background-color: white;
            width: 100vw;
            height: 100vh;
            filter: blur(80px);
        }
    }
    
    .VPopup {
        outline: none;
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        z-index: 10000000;
        border-radius: 10px;
        border: 0;
        @include light-shadow;
        background-color: #f5f5f5;
        
        &::-webkit-scrollbar {
            width: 10px;
        }
        
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #1a1b21;
        }
        
        &::-webkit-scrollbar-track {
            background-color: #333548;
            box-shadow: inset 0 1px 5px 0 rgba(0, 0, 0, 0.5);
        }
        
        &__dialog {
            margin: 0;
            height: 100%;
            @include dark-shadow;
            border-radius: 10px;
        }
        
        &__content {
            right: auto;
            bottom: auto;
            overflow: visible;
            margin: 0;
            width: 100%;
            height: 100%;
            border-radius: 2px;
            border: 0;
        }
        
        .header {
            position: absolute;
            width: 100%;
            z-index: 1;
            top: 0;
            color: #ffffff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            background-color: $primary-color;
            
            &__title {
                padding-left: 12px;
                font-size: 12px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #ffffff;
            }
            
            &__close {
                position: relative;
                right: 5px;
                top: 0;
                cursor: pointer;
                width: 11px;
                height: 11px;
                background: transparent;
                border: 0;
                outline: none;
                padding-right: 16px;
                
                &:hover {
                    opacity: .7;
                }
                
                &:before, &:after {
                    position: absolute;
                    left: 5px;
                    content: ' ';
                    height: 12px;
                    width: 2px;
                    top: 0;
                    background-color: #fff;
                }
                
                &:before {
                    transform: rotate(45deg);
                }
                
                &:after {
                    transform: rotate(-45deg);
                }
            }
        }
        
        &__body {
            display: flex;
            width: 100%;
            height: calc(100% - 97px);
            padding-bottom: 0;
            padding-top: 30px;
            
            &__sidebar {
                display: flex;
                flex-direction: column;
                width: 10%;
                height: 100%;
                padding: 0 7px 0 7px;
            }
            
            &__content {
                overflow: auto;
                width: 100%;
                @include scrollbar-features-summary-styles;
            }
        }
        
        .footer {
            margin: 0;
            padding: 15px;
            border-top: 2px solid $primary-color;
            
            .buttons {
                font-size: 11px;
                display: flex;
                justify-content: flex-end;
            }
        }
    }
</style>
